import cn from "classnames";

import { Typography } from "shared/ui/components/Typography";

import styles from "./Cell.module.scss";

//FIXME: add typings
const Cell = ({
  children,
  className,
  minWidth,
  maxWidth,
  ...restProps
}: any) => (
  <div
    className={cn(styles.cell, className)}
    style={{ minWidth, maxWidth }}
    {...restProps}
  >
    <Typography className={styles.text} variant="h4">
      {children}
    </Typography>
  </div>
);

export default Cell;
